module.exports = "/assets/data/a3a2b9394873d6f8ae2631338970763a-LS18.data.json";